import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BrightnessMediumIcon(props: IconProps) {
    return <Icon {...props} iconKey={"brightness_medium"}/>
}
